import Event from '../../core/Event';

export default class UserAuthenticationRequested extends Event {
    public static type = 'UserAuthenticationRequested';

    constructor(public readonly login: string, public readonly password: string) {
        super(UserAuthenticationRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/user/events/UserAuthenticationRequested.ts